import * as React from 'react';
import classNames from 'classnames';
import { NvSubheading, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './ListOfLinksItem.module.esm.js';

var ListOfLinksItem = function (_a) {
    var _b = _a.fields, itemHeading = _b.itemHeading, itemBody = _b.itemBody, link = _b.link, id = _a.id;
    return (React.createElement("div", { className: styles.root, "data-testid": "list-of-links-item", id: id },
        React.createElement("div", { className: styles.textContent },
            !!itemHeading && React.createElement(NvSubheading, { level: "level1book" }, itemHeading),
            React.createElement(NvMarkdown, null, itemBody)),
        React.createElement("div", { className: styles.actions },
            React.createElement(BaseNucleobaseComponent, { classes: { link: classNames('nv-button', styles.link) }, key: link.sys.id, source: link }))));
};

export { ListOfLinksItem as default };
//# sourceMappingURL=ListOfLinksItem.esm.js.map
